export const iconFontAwesomeEditingSquarePen = (
	<i className="fa-solid fa-square-pen"></i>
);
